import { Documento, InputUpoloadDocumento, PageDocumentoInput } from '@/models/documento'
import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { print } from "graphql";

import store from "@/store"
import { Pagination } from './pagination';
import { API_URL_SERVICE } from '@/commons/config';

const documentoPage = require('@/query/documento/Page.graphql')

export class DocumentoAPI extends BaseAPI<Documento> {
  constructor() {
    super();
    this.backUrl = `${this.backUrl}/documents`;
    this.apiUrl = `${this.apiUrl}/api_app/v1`;
  }

  public list(params: any): AxiosObservable<Documento[]> {
    return this.axios.get(`${this.apiUrl}/documents`, { params: this.buildFiltered(params) })
  }

  public show(id: number): AxiosObservable<Documento> {
    return this.axios.get(`${this.apiUrl}/documents/${id}`);
  }

  public showPublic(secretToken: string, documentId: number): AxiosObservable<any> {
    const apiUrl = `${API_URL_SERVICE}/api_app/v1`;
    return this.axios.get(`${apiUrl}/public/solicitations/${secretToken}/documents/${documentId}`)
  }

  public download(body: Documento): AxiosObservable<any> {
    return this.axios.get(`${this.backUrl}/${body.id}/download`, {
      params: { attachment: true },
      responseType: "blob"
    });
  }

  public uploadFile(orderId: number, documentId: number, body: any): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${orderId}/documents/${documentId}/upload`, body);
  }

  public uploadFilePublic(orderId: number, documentId: number, body: any): AxiosObservable<any> {
    const apiUrl = `${API_URL_SERVICE}/api_app/v1`;
    return this.axios.post(
      `${apiUrl}/public/solicitations/${orderId}/documents/${documentId}/upload`, body);
  }

  public approve(id: number): AxiosObservable<Documento> {
    return this.axios.patch(`${this.apiUrl}/documents/${id}/approve`);
  }

  public refuse(id: number, reason: string): AxiosObservable<Documento> {
    return this.axios.patch(`${this.apiUrl}/documents/${id}/refuse`, { reason });
  }

  public update(id: number, body: any): AxiosObservable<Documento> {
    return this.axios.patch(`${this.apiUrl}/documents/${id}`, { ...body });
  }
}
